<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.reason')"
    resource="reasons"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/reasons.js';

@Component
export default class Reasons extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'is_active_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      'is_active',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      'is_active',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'reasons.edit', params: { id: row.id } }
        }
      },
      row.is_active && {
        component: 'confirmButton',
        props: {
          label: '隐藏',
          type: 'primary',
          can: 'reasons.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/reasons/${row.id}/is_active_to_false`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      !row.is_active && {
        component: 'confirmButton',
        props: {
          label: '显示',
          type: 'primary',
          can: 'reasons.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/reasons/${row.id}/is_active_to_true`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'reasons.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/reasons',
    name: 'reasons.index',
    component: Reasons,
    props: {
      type: 'index',
    }
  },
  {
    path: '/reasons/new',
    name: 'reasons.new',
    component: Reasons,
    props: {
      type: 'new',
    }
  },
  {
    path: '/reasons/:id',
    name: 'reasons.show',
    component: Reasons,
    props: {
      type: 'show',
    }
  },
  {
    path: '/reasons/:id/edit',
    name: 'reasons.edit',
    component: Reasons,
    props: {
      type: 'edit'
    }
  }
]
</script>
